import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getSalesOrderDispatch,
  createDispatchFromSO
}
from "../../api/dispatchApi";

const DispatchFromSO = () => {

  const { id } =
  useParams();

  const navigate =
  useNavigate();

  const [order,setOrder] =
  useState({});

  const [items,setItems] =
  useState([]);

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    const res =
    await getSalesOrderDispatch(
      id
    );

    setOrder(
      res.data.data.order
    );

    setItems(
      res.data.data.items
    );

  };

  const saveDispatch =
  async()=>{

    try{

      await createDispatchFromSO({

        sales_order_id:
        order.id,

        customer_id:
        order.customer_id,

        items

      });

      alert(
        "Dispatch Completed"
      );

      navigate(
        "/sales-order-list"
      );

    }
    catch(error){

      console.log(error);

    }

  };

  return(

    <MainLayout>

      <div className="card">

        <div className="card-header">

          <h5>

            Dispatch Against Sales Order

          </h5>

        </div>

        <div className="card-body">

          <div className="mb-3">

            <strong>
              SO No :
            </strong>

            {order.so_no}

          </div>

          <div className="mb-3">

            <strong>
              Customer :
            </strong>

            {order.customer_name}

          </div>

          <table className="table">

            <thead>

              <tr>

                <th>
                  Product
                </th>

                <th>
                  Qty
                </th>

              </tr>

            </thead>

            <tbody>

              {
                items.map(
                  item=>(

                    <tr
                      key={item.id}
                    >

                      <td>

                        {
                          item.product_name
                        }

                      </td>

                      <td>

                        {
                          item.quantity
                        }

                      </td>

                    </tr>

                  )
                )
              }

            </tbody>

          </table>

          <button
            className="btn btn-success"
            onClick={
              saveDispatch
            }
          >

            Complete Dispatch

          </button>

        </div>

      </div>

    </MainLayout>

  );

};

export default DispatchFromSO;